import { clientDetails } from '../constants';
import { getLoginUserId } from '../utils/Helpers';

export const userAcitivityWorkerHelper = ({
  quickSync,
  customPayload = {},
  onComplete = () => {},
}) => {
  const logged_in_user = localStorage.getItem('logged_in_user') || '';
  const authToken = localStorage.getItem('access_token');
  const clientId = localStorage.getItem('client_id');
  const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
  if (parseInt(clientDetails?.user_activity_log) !== 1) {
    return;
  }

  const basePayload = {
    user: logged_in_user,
    user_id: getLoginUserId(),
    client_id: clientDetails?.client_id,
    userWorkroomId: userInfo?.userWorkroom_id
      ? userInfo?.userWorkroom_id
      : null,
    userWorkRoomName: userInfo?.userWorkroom_name
      ? userInfo?.userWorkroom_name
      : null,
    userTeamId: userInfo?.userTeam_id ? userInfo?.userTeam_id : null,
    userTeamName: userInfo?.userTeam_name ? userInfo?.userTeam_name : null,
  };

  const worker = new Worker(
    new URL('./userActivityWorker.js', import.meta.url),
    { type: 'module' }
  );

  worker.onmessage = e => {
    const { success } = e.data;
    if (onComplete) onComplete(success);
    worker.terminate();
  };

  worker.onerror = err => {
    console.error('Worker error:', err);
    if (onComplete) onComplete(false);
    worker.terminate();
  };
  worker.postMessage({
    quickSync,
    payload: { ...basePayload, ...customPayload },
    authToken,
    clientId,
  });
};

export const getChangedValues = (newData, oldData) => {
  const changedKeys = [];

  const compare = (obj1, obj2, path = '') => {
    Object.keys(obj1).forEach(key => {
      const val1 = obj1[key];
      const val2 = obj2 ? obj2[key] : undefined;

      // New key in newData
      if (!(key in (obj2 || {}))) {
        changedKeys.push(`${path}${key}`);
        return;
      }

      // Special handling for debit_user array
      if (Array.isArray(val1) && key === 'debit_user') {
        const oldArr = Array.isArray(val2) ? val2 : [];
        val1.forEach((user, index) => {
          const oldUser = oldArr[index];
          if (!oldUser) {
            if (user.user_name) {
              const nameKey = user.user_name.replace(/\s+/g, '_');
              if (user.user_name) changedKeys.push(`user${index + 1}_name`);
              if (user.user_id) changedKeys.push(`user${index + 1}_id`);
              if (user.amount !== undefined)
                changedKeys.push(`${nameKey}_amount`);
            }
            return;
          }
          Object.keys(user).forEach(innerKey => {
            if (user[innerKey] !== oldUser[innerKey]) {
              if (innerKey === 'amount' && user.user_name) {
                const nameKey = user.user_name.replace(/\s+/g, '_');
                changedKeys.push(`${nameKey}_amount`);
              } else if (innerKey === 'user_name') {
                changedKeys.push(`user${index + 1}_name`);
              } else if (innerKey === 'user_id') {
                changedKeys.push(`user${index + 1}_id`);
              } else {
                changedKeys.push(`${path}${key}[${index}].${innerKey}`);
              }
            }
          });
        });
        return;
      }

      // Generic arrays
      if (Array.isArray(val1)) {
        const oldArr = Array.isArray(val2) ? val2 : [];
        val1.forEach((item, index) => {
          const oldItem = oldArr[index];
          if (!oldItem) {
            changedKeys.push(`${path}${key}[${index}]`);
            return;
          }
          if (typeof item === 'object' && item !== null) {
            // shallow compare object in array
            const primitives1 = Object.fromEntries(
              Object.entries(item).filter(([item]) => typeof item !== 'object')
            );
            const primitives2 = Object.fromEntries(
              Object.entries(oldItem).filter(
                ([item]) => typeof item !== 'object'
              )
            );
            if (JSON.stringify(primitives1) !== JSON.stringify(primitives2)) {
              changedKeys.push(`${path}${key}[${index}]`);
            }
          } else if (item !== oldItem) {
            changedKeys.push(`${path}${key}[${index}]`);
          }
        });
        return;
      }

      // Objects (shallow compare only top-level primitives)
      if (val1 && typeof val1 === 'object') {
        const primitives1 = Object.fromEntries(
          Object.entries(val1).filter(([value]) => typeof value !== 'object')
        );
        const primitives2 = val2
          ? Object.fromEntries(
              Object.entries(val2).filter(
                ([value]) => typeof value !== 'object'
              )
            )
          : {};
        if (JSON.stringify(primitives1) !== JSON.stringify(primitives2)) {
          changedKeys.push(`${path}${key}`);
        }
        return;
      }

      // Primitive comparison
      if (val1 !== val2) {
        changedKeys.push(`${path}${key}`);
      }
    });
  };

  compare(newData, oldData);
  return [...new Set(changedKeys)];
};

export const noOneHasPermission = (tenantMapping = []) => {
  return (
    Array.isArray(tenantMapping) &&
    tenantMapping?.every(item => item?.hasWebPermission === false)
  );
};
